import { useExecuteApi } from "@/composables/api/useExecuteApi";
import {
  createAddCustomerReviewRequest,
  createDeleteCustomerReviewRequest,
  createGetCustomerReviewsRequest,
  createUpdateCustomerReviewRequest,
} from "@/services/requests/customerReviewRequests.js";

export function useCustomerReviewApi() {
  const { executeApi } = useExecuteApi();

  const getCustomerReviews = () =>
    executeApi({
      requestFactory: createGetCustomerReviewsRequest,
      dataPath: "data.customerReviews",
      requireData: false,
      message: {
        success: "customerSession.api.loadSuccess",
        error: "customerSession.api.loadError",
      },
    });

  const addCustomerReview = (customerReview) =>
    executeApi({
      requestFactory: createAddCustomerReviewRequest,
      requestArgs: [customerReview],
      dataPath: "data",
      requireData: false,
      message: {
        success: "customerSession.api.saveSuccess",
        error: "customerSession.api.saveError",
      },
    });

  const updateCustomerReview = (customerReview) =>
    executeApi({
      requestFactory: createUpdateCustomerReviewRequest,
      requestArgs: [customerReview],
      dataPath: "data",
      requireData: false,
      message: {
        success: "customerSession.api.saveSuccess",
        error: "customerSession.api.saveError",
      },
    });

  const deleteCustomerReview = (id) =>
    executeApi({
      requestFactory: createDeleteCustomerReviewRequest,
      requestArgs: [id],
      dataPath: "data",
      requireData: false,
      message: {
        success: "customerSession.api.deleteSuccess",
        error: "customerSession.api.deleteError",
      },
    });

  return {
    getCustomerReviews,
    addCustomerReview,
    updateCustomerReview,
    deleteCustomerReview,
  };
}
